export default __webpack_public_path__ + "static/media/image.brax-marketing.7f27c5ce.png";